import { yupResolver } from "@hookform/resolvers/yup";
import classnames from "classnames";
import Link from "next/link";
import { useForm } from "react-hook-form";
import * as y from "yup";

import { Button } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import formStyles from "@/styles/Form.module.scss";
import loginStyles from "@/styles/Login.module.scss";
import processStyles from "@/styles/Process.module.scss";

import ErrorMessage from "./Parts/ErrorMessage";
import { PasswordField, TextField } from "./Parts/index";

const schema = y.object().shape({
  loginid: y
    .string()
    .email("メールアドレスの形式で入力してください。")
    .required("メールアドレスが入力されていません。"),
  password: y.string().required("パスワードが入力されていません。"),
});

// ログイン画面3
export default function SpooxLoginForm(props) {
  const { onSubmit, error, mappingError } = props;
  const { formState, register, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
  });
  const { isDirty, isValid, isSubmitting, errors } = formState;
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <div className={`${processStyles.content} ${loginStyles.loginSet}`}>
        <div
          className={`${loginStyles.loginSection} ${loginStyles.formSection}`}
        >
          <h3 className={loginStyles.sectionTitle}>
            スカパー！メンバーズIDに旧SPOOXアカウントを連携
            <div className={loginStyles.normalWeight}>
              スカパー！メンバーズIDへ連携したい旧SPOOX
              ID・パスワードをご入力ください。
            </div>
          </h3>
          <div className={loginStyles.sectionInner}>
            {error && <ErrorMessage msg={error.message} />}
            {mappingError && <ErrorMessage msg={mappingError.message} />}
            <fieldset>
              <TextField
                {...register("loginid")}
                title="旧SPOOX ID（Eメールアドレス）"
                type="email"
                placeholder="旧SPOOX IDを入力してください"
                error={errors.loginid?.message}
              />
            </fieldset>
            <fieldset>
              <PasswordField
                {...register("password")}
                title="旧SPOOXのパスワード"
                placeholder="パスワードを入力"
                error={errors.password?.message}
              />
              <p className={loginStyles.caption}>
                ※現在ご契約中の商品及び登録済み支払方法の継続利用には、旧SPOOX
                IDとスカパー！メンバーズIDの連携が必要です。
                <br />
                ※連携後は旧SPOOX
                IDはご使用できませんので、連携したスカパー！メンバーズIDでログインしてください。
              </p>
              <p
                className={classnames(
                  formStyles.formInputInfo,
                  processStyles.center
                )}
              >
                パスワードをお忘れの方は
                <Link href={routes.passwordRemind} className="mainColor">
                  こちらから
                </Link>
                リセットできます。
              </p>
            </fieldset>
            <div className={loginStyles.loginBtnArea}>
              <Button
                type="submit"
                fillMainColor
                large
                fontFixed
                fontBold
                disabled={!isDirty || !isValid}
                loading={isSubmitting}
              >
                ID連携
              </Button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
